import * as React from 'react';

export default function LogoutIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}>
      <mask
        id="prefix__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={14}
        height={14}
      >
        <path
          transform="rotate(180 14 14)"
          fill="currentColor"
          d="M14 14h14v14H14z"
        />
      </mask>
      <g mask="url(#prefix__a)">
        <path
          d="M4.81 4.91c.107.133.16.283.16.45a.582.582 0 01-.16.42L3.731 6.906h4.186a.55.55 0 01.415.175.602.602 0 01.168.434.604.604 0 01-.168.434.552.552 0 01-.415.175H3.73l1.08 1.127a.606.606 0 01.174.434.607.607 0 01-.175.435.512.512 0 01-.4.183.532.532 0 01-.402-.168l-2.1-2.194a.54.54 0 01-.124-.198.707.707 0 01-.036-.228c0-.081.012-.158.036-.229a.541.541 0 01.124-.198l2.1-2.193c.127-.132.265-.19.416-.175.15.015.28.078.386.19zm6.023-2.878c.321 0 .596.119.825.357.228.24.342.526.342.861v8.531c0 .335-.114.622-.342.861a1.101 1.101 0 01-.825.358h-3.5a.554.554 0 01-.416-.175.605.605 0 01-.167-.434c0-.173.056-.318.167-.434a.553.553 0 01.416-.176h3.5v-8.53h-3.5a.553.553 0 01-.416-.176.603.603 0 01-.167-.434c0-.173.056-.317.167-.434a.553.553 0 01.416-.175h3.5z"
          fill="#3A3A49"
        />
      </g>
    </svg>
  );
}
